/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/motherhood/components/standalone/Byline/theme';

export const BylineTheme = theme;
